import { useContext } from 'react'

import { Box } from '@material-ui/core'
import { Alert } from '@material-ui/lab'

import { CONTENT_TYPES } from '@scoir/college-content'

import ContentModalContext from '../../ContentModalProvider/Context'
import Section from '../../components/Section'
import AcademicFocuses from './AcademicFocuses'
import Categories from './Categories'

const Audience = () => {
  const { type, exceed5Tags } = useContext(ContentModalContext)
  const isEvent = type === CONTENT_TYPES.SESSIONS
  const subTitle = isEvent
    ? 'What is this event about? (Select up to 5 topics)'
    : "What is this post about? We don't recommend adding more than 10 topics."

  return (
    <Section
      title="Topics"
      subTitle={
        <Box
          mt={-2}
          mb={-2}
        >
          {subTitle}
        </Box>
      }
    >
      {isEvent && exceed5Tags && <Alert severity="error">Please select no more than 5 topics.</Alert>}
      <Box
        display="flex"
        position="relative"
        flexDirection="column"
      >
        <AcademicFocuses focusOnly />
        <Categories />
      </Box>
    </Section>
  )
}

export default Audience
